import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-[#0a0a0a]">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/49efe823492b3a1242939e6a54fa4b08.jpg"
          alt="Appalachian Industry"
          className="w-full h-full object-cover object-top opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0a0a0a] via-[#0a0a0a]/80 to-transparent" />
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10 pt-28 pb-20">
        <div className="max-w-3xl">
          <div className="inline-block border border-[#D4AF37]/40 px-4 py-1.5 mb-8">
            <span className="text-[#D4AF37] text-xs font-bold uppercase tracking-[0.3em] font-sans">Serving All 50 States</span>
          </div>
          <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl text-white leading-tight mb-6 uppercase">
            Insurance Solutions<br />
            <span className="text-[#D4AF37]">Built for Business</span><br />
            Owners in Appalachia
          </h1>
          <p className="text-white/60 text-lg leading-relaxed mb-10 font-sans max-w-xl">
            We help local Contractors, Tradesmen, Coal Mines, Commercial Auto, Construction Companies, and Business Owners get the coverage they need to protect their business and grow with confidence.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link to="/contact"
              className="px-8 py-4 bg-[#D4AF37] text-black font-bold text-sm uppercase tracking-widest rounded-md hover:bg-[#e8c84e] transition-all duration-200 text-center whitespace-nowrap cursor-pointer">
              Get a Free Quote
            </Link>
            <Link to="/services"
              className="px-8 py-4 border border-white/30 text-white font-bold text-sm uppercase tracking-widest rounded-md hover:border-[#D4AF37] hover:text-[#D4AF37] transition-all duration-200 text-center whitespace-nowrap cursor-pointer">
              Our Services
            </Link>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="absolute bottom-0 left-0 right-0 bg-[#D4AF37] py-3">
        <div className="max-w-7xl mx-auto px-6 md:px-10 flex flex-col sm:flex-row items-center justify-between gap-2">
          <span className="text-black text-xs font-bold uppercase tracking-widest font-sans">24/7 Emergency Claims Line</span>
          <a href="tel:6062691190" className="text-black text-sm font-bold font-sans hover:underline cursor-pointer">606-269-1190</a>
          <span className="text-black/70 text-xs font-sans uppercase tracking-wider">Mon–Fri 9AM–4:30PM &nbsp;|&nbsp; Sat–Sun Closed</span>
        </div>
      </div>
    </section>
  );
}
